<highcharts-chart *ngIf="chartOptions"
  [Highcharts]="Highcharts"
  [options]="chartOptions"
[(update)]="updateFlag"

  style="width: 100%; height: 600px; display: block;"
></highcharts-chart>
